<div class="container">
    <div class='center'>
        <div class='loading'>
            <div class='loading-inner'></div>
            <div class='loading-inner'></div>
        </div>
    </div>
</div>